var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l6bwb2e9"},[_c('div',{ref:"light"},[_vm._t("default")],2),(_vm.status != 'normal')?_c('div',{ref:"shadow",staticClass:"l6bw5u3t"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }